import type { PersistedStopwatch } from "../domain/types/stopwatch.types";
import { getDateKey } from "shared/utils/date";

const STORAGE_KEY = "timer:accurate:v6";

const safeParse = (raw: string | null): PersistedStopwatch | null => {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PersistedStopwatch;
  } catch {
    return null;
  }
};

export const readPersisted = (): PersistedStopwatch => {
  const today = getDateKey();
  const parsed = safeParse(localStorage.getItem(STORAGE_KEY));

  if (!parsed) {
    return {
      isRunning: false,
      startedAt: null,
      sessionAccumulated: 0,
      sessionDateKey: today,
      sessionStartedAt: null,
    };
  }

  return {
    isRunning: parsed.isRunning ?? false,
    startedAt: parsed.startedAt ?? null,
    sessionAccumulated: parsed.sessionAccumulated ?? 0,
    sessionDateKey: parsed.sessionDateKey ?? today,
    sessionStartedAt: parsed.sessionStartedAt ?? null,
  };
};

export const writePersisted = (data: PersistedStopwatch) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const STOPWATCH_STORAGE_KEY = STORAGE_KEY;

